import { CircularProgress, makeStyles } from '@material-ui/core';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router';
import useCheckMobileScreen from '../../../hooks/useWidth';
import WithPatientFileHeader from '../../PatientFileHeader/WithPatientFileHeader';
// import { NavLink } from 'react-router-dom';
import FormCard from '../Form/FormCard';

const styles = makeStyles((theme) => ({
    container: {
        padding: ({ isMobile }) => (isMobile ? '24px 24px 0' : '5px 24px'),
        // height: 'calc(100vh - 135px)',
        overflow: 'auto',
        [theme.breakpoints.up(1025)]: {
            padding: '5px 24px',
            height: 'calc(100vh - 70px)'
        }
    },
    progressContainer: {
        justifyContent: 'center',
        alignItems: 'center',
        display: 'flex',
        height: '100%'
    }
}));
const FormComparisonLinks = () => {
    const isMobile = useCheckMobileScreen();
    const classes = styles({ isMobile });
    const { formId, id } = useParams();
    const history = useHistory();
    const { clinicId } = useParams();
    const allForms = useSelector((state) => state.dynamicForms.allForms);

    useEffect(() => {
        if (!formId && allForms && !isMobile) {
            const firstFormName = allForms[0]?.name;
            history.replace(`/${clinicId}/patient/${id}/forms/comparison/${firstFormName}`);
        }
    }, [allForms, formId, isMobile]);

    return (
        <div className={classes.container}>
            {allForms ? (
                allForms.map((item) => (
                    <>
                        <FormCard
                            key={item.id}
                            items={item}
                            path={`/${clinicId}/patient/${id}/forms/comparison/${item.name}`}
                            isComparison
                        />
                    </>
                ))
            ) : (
                <div className={classes.progressContainer}>
                    <CircularProgress />
                </div>
            )}
        </div>
    );
};

export default WithPatientFileHeader(FormComparisonLinks, ['sidebar', 'visit'], true, false, true);
